<template>
  <div>
    <router-link :to="'/categories/' + item.id">
      <img
        :src="base_url + item.image"
        alt=""
        width="100%"
        class="card-img-top">
      <div class="card-body">
        <h5 class="card-title">{{ item.description }}</h5>
      </div>
    </router-link>
  </div>
</template>

<script>
  import ApiConfig from '../../communicate/ApiConfig'
  import defaultImage from '../../assets/images/default.png';

  export default {
    name: "ServiceCategory",
    props: ["item"],
    data() {
      return {
        base_url: ApiConfig.base_url
      }
    },
    methods: {
      replaceByDefault(e) {
        e.target.src = defaultImage;
      },
    }
  }
</script>

<style scoped>
  .card-title {
    font-size: 12px;
    color: #000;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/ServiceCategory.vue